import { useEffect } from 'react'

const BASE = 'GlobalX'

/** Sets the document title ("<page> — GlobalX"); no argument restores the site title. */
export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} — ${BASE}` : `${BASE} — Smarter Markets`
  }, [title])
}
